// Display only. Never use the formatted string as a payment/refund payload.
export function formatOrderMoney(value:unknown):string {
 if(value===null || value===undefined || typeof value==='boolean' || (typeof value!=='number' && typeof value!=='string'))return '—'
 let text=String(value).trim()
 if(!text || !Number.isFinite(Number(text)))return '—'
 if(/[eE]/.test(text))text=Number(text).toLocaleString('en-US',{useGrouping:false,maximumFractionDigits:20})
 const match=/^([+-]?)(\d*)(?:\.(\d*))?$/.exec(text)
 if(!match || !(match[2] || match[3]))return '—'
 const fraction=match[3] || '',digits=((match[2] || '0').replace(/^0+(?=\d)/,'')+(fraction[0] || '0')).split('')
 if(Number(fraction[1] || 0)>=5){let carry=1;for(let i=digits.length-1;i>=0 && carry;i--){const n=Number(digits[i])+carry;digits[i]=String(n%10);carry=n>9?1:0}if(carry)digits.unshift('1')}
 const amount=digits.slice(0,-1).join('')+'.'+digits[digits.length-1]
 return (match[1]==='-' && amount!=='0.0'?'-':'')+amount
}
export function isOrderMoneyField(field:unknown):boolean {
 return /(?:price|amount|fee|money|balance|deposit)$/i.test(String(field || ''))
}
export function formatOrderMoneyCell(value:unknown,field:unknown):unknown {
 if(!isOrderMoneyField(field))return value
 if(typeof value==='string' && value.trim() && !Number.isFinite(Number(value))){const match=/^([￥¥]\s*)([+-]?\d+(?:\.\d+)?)(\s*元?)$/.exec(value.trim());return match?match[1]+formatOrderMoney(match[2])+match[3]:value}
 return formatOrderMoney(value)
}
